module.exports = __webpack_public_path__ + "img/56fd8d8542b500fcc9772c276539e351.png";